document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.querySelector('.search-toggle-btn');
    const searchForm = document.querySelector('.search-form-desktop');
    if (!toggleBtn || !searchForm) return;

    toggleBtn.addEventListener('click', function() {
        const isActive = searchForm.classList.toggle('is-active');
        toggleBtn.setAttribute('aria-expanded', isActive);

        if (isActive) {
            const input = searchForm.querySelector('input[type="search"]');
            if (input) input.focus();
        }
    });
    document.addEventListener('click', function(e) {
        if (!searchForm.contains(e.target) && !toggleBtn.contains(e.target)) {
            if (searchForm.classList.contains('is-active')) {
                searchForm.classList.remove('is-active');
                toggleBtn.setAttribute('aria-expanded', 'false');
            }
        }
    });
});



/* Accessible typeahead with min chars, helpful messages and keyboard support.
   Now supports both desktop and mobile search fields.
*/
(function(){
    const minChars = 3;
    const debounceMs = 250;

    // Debounce helper
    function debounce(fn, wait) {
        let t;
        return function(...args) {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    // Initialize typeahead for a given input + listbox pair
    function initTypeahead(input, listbox) {
        if (!input || !listbox) return;

        let activeIndex = -1;
        let suggestions = [];

        function clearSuggestions() {
            listbox.innerHTML = '';
            listbox.hidden = true;
            input.setAttribute('aria-expanded', 'false');
            input.removeAttribute('aria-activedescendant');
            activeIndex = -1;
            suggestions = [];
        }

        function renderMessage(message) {
            listbox.innerHTML = '';
            const li = document.createElement('li');
            li.id = input.id + '-msg';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-disabled', 'true');
            li.className = 'search-msg';
            li.textContent = message;
            listbox.appendChild(li);

            listbox.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            activeIndex = -1;
            suggestions = [];
        }

        function renderSuggestions(items, query) {
            listbox.innerHTML = '';
            suggestions = items;
            if (!items.length) {
                renderMessage(query
                    ? `Geen resultaten gevonden voor "${query}"`
                    : 'Geen resultaten gevonden'
                );
                return;
            }

            listbox.hidden = false;
            input.setAttribute('aria-expanded', 'true');

            items.forEach((item, i) => {
                const li = document.createElement('li');
                li.id = input.id + '-option-' + i;
                li.setAttribute('role', 'option');
                li.setAttribute('aria-selected', 'false');

                const titleSpan = document.createElement('span');
                titleSpan.className = 'result-title';
                titleSpan.textContent = item.title && item.title.rendered ? item.title.rendered : '(geen titel)';

                const typeSpan = document.createElement('span');
                typeSpan.className = 'result-type';
                // const typeText = (item.type === 'page') ? 'Pagina' : (item.type === 'post' ? 'Bericht' : item.type);
                // typeSpan.textContent = typeText;

                // li.setAttribute('aria-label', `${titleSpan.textContent} — ${typeText}`);
                li.setAttribute('aria-label', `${titleSpan.textContent}`);

                li.addEventListener('mousedown', () => {
                    window.location.href = item.link;
                });

                li.appendChild(titleSpan);
                // li.appendChild(typeSpan);
                listbox.appendChild(li);
            });

            activeIndex = -1;
        }

        async function fetchSuggestions(query) {

            try {
                // Single fetch to custom endpoint
                const res = await fetch("/wp-json/custom/v1/search?s=" + encodeURIComponent(query));
                const results = res.ok ? await res.json() : [];

                renderSuggestions(results, query);
            } catch (err) {
                renderMessage('Kan zoekresultaten niet ophalen. Probeer het later opnieuw.');
                console.error(err);
            }
        }

        const debouncedFetch = debounce((q) => fetchSuggestions(q), debounceMs);

        input.addEventListener('input', () => {
            const q = input.value.trim();

            if (q.length === 0) {
                clearSuggestions();
                return;
            }

            if (q.length < minChars) {
                const remaining = minChars - q.length;
                const plural = remaining === 1 ? 'teken' : 'tekens';
                renderMessage(`Typ nog ${remaining} ${plural} om te zoeken`);
                return;
            }

            debouncedFetch(q);
        });

        input.addEventListener('keydown', (e) => {
            const optionsAll = Array.from(listbox.querySelectorAll('[role="option"]'));
            const selectableOptions = optionsAll.filter(opt => opt.getAttribute('aria-disabled') !== 'true');

            if (!selectableOptions.length) {
                if (e.key === 'Escape') clearSuggestions();
                return;
            }

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    activeIndex = (activeIndex + 1) % selectableOptions.length;
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    activeIndex = (activeIndex - 1 + selectableOptions.length) % selectableOptions.length;
                    break;
                case 'Enter':
                    if (activeIndex >= 0 && suggestions[activeIndex]) {
                        e.preventDefault();
                        window.location.href = suggestions[activeIndex].link;
                    }
                    break;
                case 'Escape':
                    clearSuggestions();
                    break;
                default:
                    return;
            }

            const selectedOption = selectableOptions[activeIndex];
            optionsAll.forEach(opt => opt.setAttribute('aria-selected', 'false'));
            if (selectedOption) {
                selectedOption.setAttribute('aria-selected', 'true');
                input.setAttribute('aria-activedescendant', selectedOption.id);
                selectedOption.scrollIntoView({ block: 'nearest' });
            } else {
                input.removeAttribute('aria-activedescendant');
            }
        });

        input.addEventListener('blur', () => {
            setTimeout(() => clearSuggestions(), 200);
        });

        document.addEventListener('click', (e) => {
            if (!input.contains(e.target) && !listbox.contains(e.target)) {
                clearSuggestions();
            }
        });
    }

    // ✅ Initialize desktop search
    const desktopInput = document.getElementById('site-search');
    const desktopListbox = document.getElementById('search-suggestions');
    initTypeahead(desktopInput, desktopListbox);

    // ✅ Initialize mobile search
    const mobileInput = document.getElementById('site-search-mobile');
    const mobileListbox = document.getElementById('search-suggestions-mobile');
    initTypeahead(mobileInput, mobileListbox);

})();